export const templateParamsRegex = new RegExp('{{\\d+}}', 'gm'); ///{{\d+}}/gm

export const fillTypes = Object.freeze({
  FREE_TEXT: 'free_text',
  CLIENT_FIELD: 'client_field',
  IMPORT_FIELD: 'import_field'
});

export const TYPES_BROADCAST_LIST = Object.freeze({
  TRANSFER_TO_QUEUE: 1,
  CLOSE_ON_FIRST_RESPONSE: 2,
  TRANSFER_TO_QUEUE_WITH_FIRST_RESPONSE: 3,
  TRANSFER_TO_DIALOG_TREE: 4,
  TRANSFER_TO_WATSON: 5,
  CLOSE_AFTER_SEND: 6,
  TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL: 7
});

export const broadcastTypeOfClosingConversationOptions = [
  {
    label: 'Transferir para fila',
    value: TYPES_BROADCAST_LIST.TRANSFER_TO_QUEUE
  },
  {
    label: 'Encerrar na primeira resposta',
    value: TYPES_BROADCAST_LIST.CLOSE_ON_FIRST_RESPONSE
  },
  {
    label: 'Transferir para fila com primeira resposta',
    value: TYPES_BROADCAST_LIST.TRANSFER_TO_QUEUE_WITH_FIRST_RESPONSE
  },
  {
    label: 'Transferir para a Árvore de Diálogo',
    value: TYPES_BROADCAST_LIST.TRANSFER_TO_DIALOG_TREE
  },
  {
    label: 'Transferir para o Watson',
    value: TYPES_BROADCAST_LIST.TRANSFER_TO_WATSON
  },
  {
    label: 'Encerrar conversa após envio',
    value: TYPES_BROADCAST_LIST.CLOSE_AFTER_SEND
  },
  {
    label: 'Transferir para Árvore de Diálogo com protocolo',
    value: TYPES_BROADCAST_LIST.TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
  }
];
